import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { obtenerComboEstados } from '@/redux/slices/operacionesSlice/operacionesSlice';
import { useEffect, useState } from 'react';

const useComboEstados = () => {
  const dispatch = useAppDispatch();
  const { estadosCombo, estado } = useAppSelector((state) => state.operaciones);
  const [montado, setMontado] = useState(false);

  useEffect(() => {
    if (!estadosCombo) {
      if (!montado) return setMontado(true);
      dispatch(obtenerComboEstados());
    }
  }, [dispatch, montado, setMontado, estadosCombo]);

  return { estadosCombo, estado };
};

export default useComboEstados;
